module.exports = __webpack_public_path__ + "img/SZ0009.918c1fa.webp";